<template>
    <div class="content content-fixed content-auth">
        <header class="navbar navbar-header navbar-header-fixed">
            <div class="navbar-brand">
                <a href="#" class="df-logo"><img src="../../assets/img/RubiesLogo.png" width="150" height="50"></a>
            </div>
            <div class="navbar-right">
                <a href="#" class="btn btn-social text-danger"><i class="fab fa-facebook"></i></a>
                <a href="#" class="btn btn-social text-danger"><i class="fab fa-instagram"></i></a>
                <a href="#" class="btn btn-social text-danger"><i class="fab fa-twitter"></i></a>

            </div><!-- navbar-right -->
        </header>
        <div class="container">
            <div class="media align-items-stretch justify-content-center ht-100p pos-relative">
                <div class="media-body align-items-center d-none d-lg-flex">
                    <div class="mx-wd-600">
                        <img src="../../assets/img/img.jpg" class="img-fluid" alt="">
                    </div>

                </div><!-- media-body -->
                <div class="sign-wrapper mg-lg-l-50 mg-xl-l-60 col-md-4">
                    <div class="wd-100p">
                        <h3 class="tx-color-01 mg-b-5">Sign In</h3>
                        <p class="tx-color-03 tx-16 mg-b-40">Welcome back! Please signin to continue.</p>
                        <logon-form></logon-form>
                        <div class="divider-text">or</div>
                        <div class="tx-13 mg-t-20 tx-center"> <a href="http://businessaccount.rubies.ng/"  target="_blank" class="tx-13">Open a Rubies Business Account</a></div>
<!--                        <div class="tx-13 mg-t-20 tx-center">Don't have an account? <router-link to="/register">Create an Account</router-link></div>-->
                    </div>
                </div><!-- sign-wrapper -->
            </div><!-- media -->
        </div><!-- container -->
    </div><!-- content -->

</template>

<script>
    import LogonForm from "../../components/form/LogonForm";
    export default {
        name: "Logon",
        components:{
            LogonForm
        },
        computed:{},
        mounted() {
            //console.log('authLoading>>> ', this.system.appLoading)
        }
    }
</script>

<style scoped>

</style>
